import React, { memo } from 'react';
import classnames from 'classnames';

import { isMediaQuery } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import Utils from '~/core/scripts/utils';

import './tooltip.styl';

const TOOLTIP_WIDTH = 250;
const BAR_WIDTH = 100;

const GEHALT_MAX = 17.4;
const MIETE_MAX = 33.4;

const BAR_MAX = Math.max(GEHALT_MAX, MIETE_MAX);

const Tooltip = memo(({ data, pos, isVisible, onClose } ) => {
  const style = isMediaQuery(769) ? { left: `${pos.x + 15}px`, top: `${pos.y - 75}px` } : {};
  const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth;
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted });
  const isClosable = Utils.isTouch || !isMediaQuery(769);

  if (!data) {
    return null;
  }

  const currValue = data.value;
  const title = data.title;
  const subtitle = data.subtitle;
  const miete = data.miete;
  const gehalt = data.gehalt;
  const dif = data.dif;
  
  // condition spam because react doesn't know comparison operators
  const result_lesser = (dif <= -1);
  const result_similar = (dif > -1 && dif < 1);
  const result_greater = (dif >= 1);

  const handleClose = evt => {
    evt.preventDefault();
    evt.stopPropagation();

    onClose();
  };

  // console.log("bar: "+((gehalt/GEHALT_MAX)*BAR_WIDTH));

  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        {isClosable && (
          <button className="btn close" onClick={handleClose}>
            <Icon type="close" />
          </button>
        )}
        <div className="tooltip-header">
          <div className="tooltip-title">{title}</div>
          <div className="tooltip-subtitle">{subtitle}</div>
        </div>
        <div className="tooltip-body">
          <div className="tooltip-row">
            <div className="tooltip-icon">
              <Icon type="wage" />
            </div>
            <div className="tooltip-label">
              Löhne
            </div>
            <div className="tooltip-value">
              {(function(){ return (gehalt>0)?"+":""; })()}{Utils.numberFormat(gehalt, 1)}%
            </div>
            <div className="tooltip-bar-container">
              <div className="tooltip-bar" style={{width: ((gehalt/BAR_MAX)*100)+'%'}}></div>
            </div>
          </div>
          <div className="tooltip-row">
            <div className="tooltip-icon">
              <Icon type="house" />
            </div>
            <div className="tooltip-label">
              Mieten
            </div>
            <div className="tooltip-value">
              {Utils.numberFormat(miete, 1).replace(/^([0-9])/,'+$1')}%
            </div>
            <div className="tooltip-bar-container">
              <div className="tooltip-bar" style={{width: ((miete/BAR_MAX)*100)+'%'}}></div>
            </div>
          </div>
        </div>
        {result_greater && (
          <div className="tooltip-footer greater">
            Die Mieten sind hier sogar <strong>erschwinglicher</strong> geworden, da die Löhne um&nbsp;
            {Utils.numberFormat(dif, 1)} Prozentpunkte schneller gestiegen sind.
          </div>
        )}
        {result_lesser && (
          <div className="tooltip-footer lesser">
            Hier sind die Mieten <strong>weniger erschwinglich</strong> als noch 2014. Denn sie sind um {Utils.numberFormat(Math.abs(dif), 1)} Prozentpunkte
            schneller gestiegen als die Löhne.
          </div>
        )}
        {result_similar && (
          <div className="tooltip-footer similar">
            Löhne und Mieten haben sich hier <strong>nahezu im gleichen Tempo</strong> entwickelt. 
            Der Abstand beträgt lediglich&nbsp;{Utils.numberFormat(dif, 1).replace(/^([0-9])/,'+$1')} Prozentpunkte.
          </div>
        )}
      </div>
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
